import store from '../store'
import queryString from 'query-string'

export default [
    {
        path: '/',
        name: 'home',
        meta: { title: 'Dashboard' },
        component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
      },
      {
        path: '/organization',
        name: 'Organization',
        meta: { title: 'Organização' },
        component: () => import(/* webpackChunkName: "about" */ '../views/organization/List.vue')
      },
      {
        path: '/user',
        name: 'user',
        meta: { title: 'Usuários' },
        component: () => import(/* webpackChunkName: "about" */ '../views/user/List.vue')
      },
      {
        path: '/role',
        name: 'role',
        meta: { title: 'Perfis' },
        component: () => import(/* webpackChunkName: "about" */ '../views/role/List.vue')
      },
      {
        path: '/permission',
        name: 'permission',
        meta: { title: 'Permissões' },
        component: () => import(/* webpackChunkName: "about" */ '../views/permission/List.vue')
      },
      {
        path: '/product',
        name: 'Product',
        meta: { title: 'Produtos' },
        component: () => import(/* webpackChunkName: "about" */ '../views/product/List.vue')
      },
      {
        path: '/about',
        name: 'about',
        meta: { nonRequiresAuth: true },
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },
      {
        path: '/login',
        redirect: (to) => {
          const url_redirect = store.state.credentials.authority + '?' + queryString.stringify(to.query)
          window.location.href = url_redirect
        }
      },
      {
        path: '/logout',
        redirect: (to) => {
          store.dispatch('clear_token')
          const url_redirect = store.state.credentials.authority + '?' + queryString.stringify(to.query)
          window.location.href = url_redirect
        }
      }
]